/* eslint-disable import/prefer-default-export */
import { Conversation, ConversationMessage, GetConversationSignature } from '@centecomm/portal-service';
import { conversationsActions } from '../..';
import { StateRecord, Streams, WrappedConversationEvent } from '../../../Types';
import { ConversationEventTypes, MessageSentToConversation } from '../../../Types/Conversations/Events';
import { ConversationsActionTypes } from '../../Conversations/actions';

export const conversationMessageReadHandler = (
    { conversationId, metadata, messageId }: Streams.ConversationMessageReadStreamMessage,
    conversations: StateRecord<Conversation>,
    conversationEvents: StateRecord<WrappedConversationEvent[]>,
    currentUserId: number,
    dispatch,
    getConversation: GetConversationSignature,
): void => {
    const { eventDate, userId } = metadata;

    // Message was read
    // TODO: Need to update 'last' message read for conversation

    if (currentUserId === userId) {
        if (conversations.hasOwnProperty(conversationId)) {
            const { lastMessage }: Conversation = conversations[conversationId];

            if (messageId > lastMessage.id) {
                let message: string;

                if (conversationEvents.hasOwnProperty(conversationId)) {
                    const mostRecentMessageEvent: MessageSentToConversation[] =
                        (conversationEvents[conversationId].filter(
                            (wrappedEvent: WrappedConversationEvent) => wrappedEvent.event.conversationId === conversationId,
                        )
                            .filter(
                                (wrappedEvent: WrappedConversationEvent) =>
                                    wrappedEvent.type === ConversationEventTypes.MessageSentToConversation,
                            )
                            .map((wrappedEvent: WrappedConversationEvent) => wrappedEvent.event)
                            .sort(
                                (a: MessageSentToConversation, b: MessageSentToConversation) => b.messageId - a.messageId,
                            ) as MessageSentToConversation[]) || [];

                    message = mostRecentMessageEvent[0].message;
                } else {
                    message = '';
                }

                const conversationMessage: ConversationMessage = {
                    id: messageId,
                    content: message,
                    created: eventDate,
                    userId: userId,
                };

                dispatch({
                    type: conversationsActions.UPDATE_LAST_MESSAGE,
                    payload: {
                        conversationId: conversationId,
                        message: conversationMessage,
                    },
                } as ConversationsActionTypes);
            }
        } else {
            getConversation(conversationId)
                .then((conversation: Conversation) => {
                    dispatch({
                        type: conversationsActions.ADD_CONVERSATION,
                        payload: conversation,
                    } as ConversationsActionTypes);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }
};
